module.exports = __webpack_public_path__ + "static/media/ashleigh.a0b08588.png";